import { inflate } from 'pako';

// A conversation_history assistant body is `{ content: [{ text }] }` where
// text is base64-wrapped deflate. Decodes it to the parsed agent payload.
export function decodeMessageContent(content: unknown): Record<string, any> | undefined {
  const text = (content as { content?: Array<{ text?: unknown }> })?.content?.[0]?.text;
  if (typeof text !== 'string') {
    return undefined;
  }
  try {
    const bytes = Uint8Array.from(atob(text), (character) => character.charCodeAt(0));
    const decompressed = inflate(bytes, { to: 'string' });
    return decompressed ? (JSON.parse(decompressed) as Record<string, any>) : undefined;
  } catch {
    return undefined;
  }
}
